{
    "name": "Oliebollen Scouting Raalte",
    "fullName": "Scouting Raalte",
    "description": "Bestel de heerlijke oliebollen en appelbeignets hier online! Onze oliebollen zijn dagvers, van hoge kwaliteit en smaken uitstekend!",
    "slogan": "Oliebollen bestellen? Scouting Raalte bellen!",
    "kvk_number": "08174269",
    "telephone": {
        "text": "(0572) 358375",
        "href": "0572358375"
    },
    "email": {
        "text": "oliebollen@scouting-raalte.nl",
        "href": "oliebollen@scouting-raalte.nl"
    }
}
